// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1A9v6","label":"Completed_label__2ckrx"};